import styled from 'styled-components';

export const StyledGameStageContext = styled.div`
  position: absolute;
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  overflow: hidden;

  .grid {
    position: absolute;
    width: 100%;
    height: 100%;
    .horizontal-grid {
      position: absolute;
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      .grid-box {
        width: 100%;
        height: 10%;
        border: 1px dotted palegreen;
      }
    }
    .vertical-grid {
      position: absolute;
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      .grid-box {
        width: 10%;
        height: 100%;
        border: 1px dashed palegreen;
      }
    }
  }
`;
